var text_field_default = {
  "root": "-Pxjg",
  "text": "kOY2Y",
  "input": "_4wf66",
  "small": "Mu4q5",
  "medium": "on13S",
  "large": "H3Gpc",
  "webview": "-ZTpO",
  "endAdornment": "uzulQ",
  "shown": "-WAg0",
  "value": "YI-ua",
  "spinner": "-hfjU",
  "spin": "-GHK8"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
